import { getField, updateField } from 'vuex-map-fields'
import getStaffFiltersModel from './models/staffFilters'

const staffFilters = {
  namespaced: true,
  state: {
    ...getStaffFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      state.firstName = null
      state.lastName = null
      state.active = null
    }
  }
}

export default staffFilters
